export default function Portfolio() {
  const instagramUrl = 'https://www.instagram.com/papispaving?igsh=MTdhOHkxNHB4M2pqdQ%3D%3D&utm_source=qr';

  const posts = [
    {
      id: 1,
      image: 'https://public.readdy.ai/ai/img_res/ab340586673c24086c3071aff38f73d8.jpg'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Stunning%20backyard%20patio%20transformation%20with%20natural%20stone%20pavers%20in%20warm%20earth%20tones%20featuring%20outdoor%20seating%20area%20and%20fire%20pit%20with%20lush%20landscaping%20perfect%20hardscape%20work%20for%20instagram%20showcase%20with%20golden%20hour%20lighting&width=600&height=600&seq=insta002&orientation=squarish'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20curved%20garden%20walkway%20with%20flagstone%20pavers%20winding%20through%20colorful%20flower%20beds%20and%20green%20grass%20with%20decorative%20edging%20showing%20expert%20craftsmanship%20in%20residential%20landscape%20perfect%20for%20social%20media%20with%20vibrant%20colors&width=600&height=600&seq=insta003&orientation=squarish'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Impressive%20multi%20level%20retaining%20wall%20with%20natural%20stacked%20stone%20creating%20terraced%20garden%20beds%20with%20integrated%20landscape%20lighting%20and%20plantings%20showing%20professional%20hardscape%20engineering%20perfect%20instagram%20worthy%20shot%20with%20dramatic%20angles&width=600&height=600&seq=insta004&orientation=squarish'
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=Modern%20stamped%20concrete%20driveway%20with%20decorative%20pattern%20in%20warm%20tan%20color%20leading%20to%20contemporary%20home%20entrance%20with%20clean%20professional%20finish%20quality%20concrete%20work%20perfect%20for%20social%20media%20showcase%20with%20clear%20blue%20sky&width=600&height=600&seq=insta005&orientation=squarish'
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20pool%20deck%20area%20with%20slip%20resistant%20pavers%20in%20light%20neutral%20tones%20surrounding%20sparkling%20blue%20swimming%20pool%20with%20lounge%20furniture%20showing%20professional%20hardscape%20installation%20perfect%20instagram%20post%20with%20tropical%20vibes%20and%20sunny%20weather&width=600&height=600&seq=insta006&orientation=squarish'
    },
    {
      id: 7,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20front%20entrance%20walkway%20with%20brick%20pavers%20in%20classic%20pattern%20leading%20to%20home%20front%20door%20with%20decorative%20borders%20and%20landscape%20lighting%20showing%20quality%20craftsmanship%20perfect%20for%20social%20media%20with%20welcoming%20curb%20appeal&width=600&height=600&seq=insta007&orientation=squarish'
    },
    {
      id: 8,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20curved%20garden%20retaining%20wall%20with%20natural%20stacked%20stone%20creating%20raised%20flower%20bed%20filled%20with%20colorful%20blooming%20flowers%20and%20fresh%20mulch%20showing%20professional%20hardscape%20design%20perfect%20instagram%20worthy%20landscape%20shot%20with%20vibrant%20colors&width=600&height=600&seq=insta008&orientation=squarish'
    },
    {
      id: 9,
      image: 'https://readdy.ai/api/search-image?query=Stunning%20outdoor%20living%20space%20with%20custom%20paver%20patio%20featuring%20built%20in%20seating%20wall%20and%20fire%20feature%20with%20professional%20hardscape%20installation%20and%20beautiful%20landscaping%20perfect%20for%20instagram%20showcase%20with%20evening%20ambiance%20lighting&width=600&height=600&seq=insta009&orientation=squarish'
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-green-600">Portfolio</span>
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-2xl mx-auto px-4">
            Check out our latest projects on Instagram! Click any image to visit our page.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 max-w-5xl mx-auto">
          {posts.map((post) => (
            <a
              key={post.id}
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden rounded-lg shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-full">
                <img 
                  src={post.image}
                  alt={`Papi's Paving Instagram Post ${post.id}`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <i className="ri-instagram-line text-white text-4xl sm:text-5xl transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:from-purple-700 hover:to-pink-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-instagram-line text-xl sm:text-2xl"></i>
            Follow Us on Instagram
          </a>
        </div>
      </div>
    </section>
  );
}
